import * as queryString from 'query-string';
import fetch from '../../utils/fetch-json';
import {
    FAILED_GETTING_FUND_AS_GIFT_PROJECT,
    FETCHING_FUND_AS_GIFT_PROJECT,
    GOT_FUND_AS_GIFT_PROJECT,
    NO_FUND_AS_GIFT_PROJECT,
} from './fund-as-gift-reducer';
import { isRequestTimeoutError, produceGlobalError } from '../../utils/error';
import { getFundAsGiftProject as getFundAsGiftProjectSelector } from './fund-as-gift-selectors';

export const getFundAsGiftProject =
    ({ fundAsGiftCode, skipUpdate, token, forceFetchFromBackend = false }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const query = queryString.stringify({ token, skipUpdate });
        const fullUrl = `${state.baseURL}/api/public/fund-as-gift/${fundAsGiftCode}${query ? '?' + query : ''}`;

        if (!forceFetchFromBackend) {
            const project = getFundAsGiftProjectSelector(state, fundAsGiftCode);
            if (project?.fundAsGiftCode === fundAsGiftCode) {
                return dispatch({
                    type: GOT_FUND_AS_GIFT_PROJECT,
                    data: project,
                });
            }
        }

        dispatch({ type: FETCHING_FUND_AS_GIFT_PROJECT });
        return fetch({
            url: fullUrl,
            options: {
                method: 'GET',
                timeout: 10000,
            },
            dispatch,
            getState,
        })
            .then((response) => {
                if (response.status === 204) {
                    return dispatch({ type: NO_FUND_AS_GIFT_PROJECT });
                }
                return dispatch({
                    type: GOT_FUND_AS_GIFT_PROJECT,
                    data: response.body,
                });
            })
            .catch((error) => {
                const errorData =
                    error.body ||
                    (isRequestTimeoutError(error.type)
                        ? produceGlobalError(
                              'Det tok for lang tid å hente innholdet. Prøv igjen, eller ta kontakt med oss via chatten'
                          )
                        : produceGlobalError(
                              'Noe gikk feil ved lasting av siden. Prøv igjen senere, eller ta kontakt med oss via chatten'
                          ));

                return dispatch({
                    type: FAILED_GETTING_FUND_AS_GIFT_PROJECT,
                    data: errorData,
                });
            });
    };

export const createFundAsGiftProject =
    ({ fundAsGiftCode }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = `${state.baseURL}/api/public/fund-as-gift/${fundAsGiftCode}`;
        dispatch({ type: FETCHING_FUND_AS_GIFT_PROJECT });
        return fetch({
            url: fullUrl,
            options: {
                method: 'POST',
                timeout: 10000,
            },
            body: {},
            dispatch,
            getState,
        })
            .then((response) => {
                return dispatch({
                    type: GOT_FUND_AS_GIFT_PROJECT,
                    data: response.body,
                });
            })
            .catch((error) => {
                const errorData =
                    error.body ||
                    (isRequestTimeoutError(error.type)
                        ? produceGlobalError(
                              'Det tok for lang tid å hente innholdet. Prøv igjen, eller ta kontakt med oss via chatten'
                          )
                        : produceGlobalError(
                              'Noe gikk feil ved lasting av siden. Prøv igjen senere, eller ta kontakt med oss via chatten'
                          ));

                dispatch({
                    type: FAILED_GETTING_FUND_AS_GIFT_PROJECT,
                    data: errorData,
                });
            });
    };
